import React from 'react';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import SocialListComponent from '../List/SocialListComponent';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';

const FeedsView = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ minWidth: 992 });
  const paddingLeft = (isDesktop && props.leftNavigationOpen) ? 300 : (isDesktop && !props.leftNavigationOpen ? 75 : 0);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0d1b2a 0%, #091420 100%)',
        paddingLeft: `${paddingLeft}px`,
      }}
    >
      {/* ── Sticky header ── */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 3,
          py: 1.5,
          background: 'rgba(13,27,42,0.92)',
          backdropFilter: 'blur(12px)',
          borderBottom: '1px solid rgba(255,255,255,0.07)',
        }}
      >
        <IconButton
          onClick={() => navigate(-1)}
          size="small"
          sx={{ color: 'rgba(255,255,255,0.6)', '&:hover': { color: 'white' } }}
        >
          <ArrowBackIcon />
        </IconButton>
        <DynamicFeedIcon sx={{ color: DEFAULT_THEME_COLOR, fontSize: 20 }} />
        <Typography variant="h6" sx={{ color: 'white', fontWeight: 600, fontSize: '1rem' }}>
          {params.social ? `${params.social} feeds` : 'Feeds'}
        </Typography>
      </Box>

      <Box sx={{ maxWidth: 720, mx: 'auto', px: { xs: 2, sm: 3 }, py: 3 }}>
        <SocialListComponent
          social={params.social}
          forUsername={params.username}
          hideDelete
          isAddingFeed={false}
          showFeedButton
          showSubscribeButton
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = state => ({
  leftNavigationOpen: state.common.leftNavigationOpen,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FeedsView);
